import { Box, IconButton } from "@mui/material"
import { SearchInputFilter } from "../../../../components/table/ControlledFilterTable/filter-inputs/SearchInputFilter"
import { useControlledFilterTableContainerProps } from "../../../../components/table/ControlledFilterTable/ControlledFilterTableContainer"
import { useControlledFilterTableHelpers } from "../../../../components/table/ControlledFilterTable/useControlledFilterTableUtils"
import BlockIcon from '@mui/icons-material/Block'

export const SubmissionHistoryTableFilters = () => {
    const {filters, onFilter, id} = useControlledFilterTableContainerProps()
    const {hasFilters, clearFilters} = useControlledFilterTableHelpers({filters, onFilter})
  
    return (
      <Box sx={{p: 2, display: 'flex', flexDirection: 'column', gap: 2}}>
        <Box sx={{display: 'flex', justifyContent: 'space-between'}}>
          <Box>
            <SearchInputFilter id={id && `${id}-input-search`} />
            {hasFilters && (
              <IconButton id={id && `${id}-button-clear-filters`} onClick={clearFilters}>
                <BlockIcon color='primary' />
              </IconButton>
            )}
          </Box>
  
        </Box>
  
      </Box>
    )
  }
  